import { useState } from 'react';
import { withStyles } from '@material-ui/core/styles';
import IconButton from '@material-ui/core/IconButton';
import Menu from '@material-ui/core/Menu';
import MenuItem from '@material-ui/core/MenuItem';
import MoreVertIcon from '@material-ui/icons/MoreVert';

const ActionMenu = ({ options = [] }) => {
  const [anchorEl, setAnchorEl] = useState(null);
  const open = Boolean(anchorEl);

  const handleClick = (event) => {
    event.stopPropagation();
    setAnchorEl(event.currentTarget);
  };

  const handleSelectMenuItem = (action) => {
    action && action();
    setAnchorEl(null);
  };

  return (
    <div>
      <IconButton
        aria-label="More"
        aria-owns={open ? 'long-menu' : undefined}
        aria-haspopup="true"
        onClick={handleClick}
      >
        <MoreVertIcon />
      </IconButton>
      <Menu
        id="long-menu"
        anchorEl={anchorEl}
        open={open}
        onClose={() => setAnchorEl(null)}
      >
        {options.map(option => {
          const StyledMenuItem = withStyles({
            root: {
              fontSize: 15,
              fontWeight: 500,
              color: option?.color || 'default',
            },
          })(MenuItem);

          return (
            <StyledMenuItem
              disabled={option?.disabled}
              key={option.key}
              onClick={() => handleSelectMenuItem(option.action)}
            >
              {option.label}
            </StyledMenuItem>
          );
        })}
      </Menu>
    </div>
  );
};

export default ActionMenu;
